import Dropdown from "../../c/DropDown";
import { Logout } from "../../c/Logout";
import DashboardContext from "../../contexts/dashboardContext";
import WhistlesContext from "../../contexts/whistlesContext"
import { RenderIf } from "../../helpers/RenderIf";
import MeContext from "../../MeContext";
import React, { useContext } from "react"
import { NavbarBrand } from "reactstrap"
import { T } from "../../traks";
import { CompanyPlan } from "../../c/Traks/CompanyPlan";
import { LL } from "../../c/LL";

const NavbarItem = ({ children, tabId, className = "" }) => {
	const { activeTab, setActiveTab } = useContext(DashboardContext)
	const classList = activeTab === tabId ? `primary ${className}` : `${className} my-4 light_grey_on_dark primary_hover`
	return (
		<button className={`${classList} btn dashboard_btn fw_500 w-100 d-flex justify-content-between bg-transparent`} data-cy={tabId} onClick={() => setActiveTab(tabId)}>
			{children}
		</button>
	);
};

const ChangeCompany = () => {
	const { me, setCompany, whoami } = useContext(MeContext)
	const pickedCompany = whoami.companies.find(company => company.id === me.company_id)

	return (
		<RenderIf condition={whoami.companies.length > 1}>
			<div className="mb-5">
				<span className="light_grey_on_dark my-3"><T>Company</T></span>
				<Dropdown toggleText={pickedCompany.company_name} className="txt_grey_4 set_company">
					{whoami.companies.map((company, index) =>
						<button key={"c" + index} onClick={() => setCompany(company.id)} className="txt_grey_4">{company.company_name}</button>
					)}
				</Dropdown>
			</div>
		</RenderIf>
	)
}

const DashboardNavBar = ({ userRoles, ...props }) => {
	const { me } = useContext(MeContext)
	const { nmbWhistles } = useContext(WhistlesContext)
	const EntriesText = props.render_static(<T>ENTRIES</T>).toUpperCase()
	const SettingsText = props.render_static(<T>SETTINGS</T>).toUpperCase()
	const userWhistleNumber = nmbWhistles || 0

	return (
		<div className="px-2">
			<div className="cursor_pointer mt-5 d-flex justify-content-between" >
				<NavbarBrand href={LL("/")}>
					<img src="https://static.sibilus.eu/gfx/dashboard-logo-0.svg" className="w-100 mb-5" alt="our logo" />
				</NavbarBrand>
			</div>
			<div className="mb-4">
				<span className="txt_white mb-4">
					<CompanyPlan
						me={me}
					/>
					&nbsp;
					<T>plan</T>
				</span>
			</div>
			<ChangeCompany />
			<div className="mt-5 mb-4">
				<span className="txt_grey_1 mb-4">{EntriesText}</span>
			</div>
			<NavbarItem tabId={"Whistles"}>
				<div>
					<img src="https://static.sibilus.eu/gfx/whistles-icon-1.svg" className="dashboard_icon me-3" style={{ marginTop: "-2px" }} alt="whistles_icon" />
					<T>Entries</T>
				</div>
				<RenderIf condition={userWhistleNumber}>
					<div>
						<span className="border_radius_6px px-3 py-1 bg_orange bb txt_white">{userWhistleNumber}</span>
					</div>
				</RenderIf>
			</NavbarItem>
			<div className="mt-5 mb-4">
				<span className="txt_grey_1">{SettingsText}</span>
			</div>
			{userRoles.find((role) => role === "company_administrator") && (
				<>
					<NavbarItem tabId={"Users"}>
						<div>
							<img src="https://static.sibilus.eu/gfx/users-icon-1.svg" className="dashboard_icon me-3" style={{ marginTop: "-5px" }} alt="users_icon" />
							<T>Users</T>
						</div>
					</NavbarItem>
					<NavbarItem tabId={"CompanySettings"}>
						<div>
							<img src="https://static.sibilus.eu/gfx/company-icon-1.svg" className="dashboard_icon me-3" style={{ marginTop: "-5px" }} alt="company_icon" />
							<T>Company</T>
						</div>
					</NavbarItem>
				</>
			)}
			<NavbarItem tabId={"MyAccount"}>
				<div>
					<img src="https://static.sibilus.eu/gfx/my-account-icon-1.svg" className="dashboard_icon me-3" style={{ marginTop: "-6px" }} alt="my_account_icon" />
					<T>My Account</T>
				</div>
			</NavbarItem>
			<div className="position-fixed bottom-0">
				<Logout />
			</div>
		</div>)
}

export { DashboardNavBar }
